import React from 'react';
import about_img from '../images/about-img.svg';
// import about_1_img from '../images / about - extra - 1.svg';
// import about_2_img from '../images/about-extra-2.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTools, faStream, faDatabase, faRocket } from '@fortawesome/free-solid-svg-icons';

const About = () => {
    return (
        <section id="about">
            {/* Hero Section */}
            <section className="about-hero about-hero-lean">
                <div className="container" data-aos="fade-up">
                    <div className="about-intro-panel">
                        <span className="section-kicker">About Anmatics</span>
                        <div className="row g-4 align-items-end">
                            <div className="col-lg-7">
                                <h2 className="display-5 fw-bold section-title mb-0 text-start">
                                    Practical software engineering for companies that need clarity and scale.
                                </h2>
                            </div>
                            <div className="col-lg-5">
                                <p className="lead text-muted mb-0">
                                    We build reliable enterprise applications, SaaS products, workflow automation, and AI-ready platforms for modern business operations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Who We Are */}
            <section className="about-who about-who-lean py-5">
                <div className="container">
                    <div className="row g-4 align-items-start">
                        <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
                            <div className="about-visual-panel">
                                <img
                                    src={about_img}
                                    className="img-fluid"
                                    alt="Anmatics software engineering team illustration"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left">
                            <div className="about-profile-panel">
                                <span className="section-kicker">Who We Are</span>
                                <h3 className="fw-bold mb-3">An engineering-led technology company.</h3>
                                <p className="text-muted">
                                    Anmatics Technologies turns complex business requirements into structured digital products.
                                    We work with startups, manufacturers, and established companies that need dependable product
                                    execution and systems that can scale beyond the first release.
                                </p>
                                <div className="about-focus-grid">
                                    <div>
                                        <strong>Enterprise Apps</strong>
                                        <span>Web, mobile, APIs, portals, dashboards</span>
                                    </div>
                                    <div>
                                        <strong>SaaS Products</strong>
                                        <span>Architecture, modules, workflows, release flow</span>
                                    </div>
                                    <div>
                                        <strong>Modernization</strong>
                                        <span>Angular, Node.js, .NET, cloud, databases</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4 align-items-stretch mt-1">
                        <div className="col-lg-6" data-aos="fade-right">
                            <div className="about-work-panel mt-4">
                                <span className="section-kicker">What We Do</span>
                                <h4 className="fw-bold mb-3">Product Engineering &amp; Modernization</h4>
                                {[
                                    [faSearch, "Audit existing Angular, Node.js, and .NET systems"],
                                    [faTools, "Refactor critical modules and reduce architecture debt"],
                                    [faStream, "Improve CI/CD, release flow, versioning, and rollback safety"],
                                    [faDatabase, "Optimize APIs, database design, and integration layers"],
                                    [faRocket, "Prepare products for scale, demos, launches, and long-term growth"]
                                ].map(([icon, text]) => (
                                    <div className="about-work-item" key={text}>
                                        <span><FontAwesomeIcon icon={icon} /></span>
                                        <p className="mb-0">{text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left">
                            <div className="about-work-visual-panel mt-4" aria-label="Product engineering workflow visual">
                                <svg viewBox="0 0 520 260" role="img" aria-hidden="true">
                                    <defs>
                                        <linearGradient id="workFlowPrimary" x1="72" y1="32" x2="430" y2="232" gradientUnits="userSpaceOnUse">
                                            <stop offset="0" stopColor="#2563EB" />
                                            <stop offset="1" stopColor="#14B8A6" />
                                        </linearGradient>
                                    </defs>
                                    <rect x="26" y="24" width="468" height="212" rx="22" fill="#FFFFFF" stroke="#E5E7EB" />
                                    <rect x="58" y="58" width="150" height="94" rx="14" fill="#EFF6FF" stroke="#DBEAFE" />
                                    <rect x="312" y="58" width="150" height="94" rx="14" fill="#F0FDFA" stroke="#CCFBF1" />
                                    <rect x="184" y="154" width="152" height="58" rx="14" fill="#F9FAFB" stroke="#E5E7EB" />
                                    <path d="M214 104H292" stroke="url(#workFlowPrimary)" strokeWidth="4" strokeLinecap="round" />
                                    <path d="M288 104L276 96M288 104L276 112" stroke="url(#workFlowPrimary)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M246 154L198 134" stroke="#7B2CBF" strokeWidth="3" strokeLinecap="round" opacity="0.75" />
                                    <path d="M274 154L322 134" stroke="#F97316" strokeWidth="3" strokeLinecap="round" opacity="0.75" />
                                    <circle cx="132" cy="88" r="14" fill="#2563EB" />
                                    <circle cx="386" cy="88" r="14" fill="#14B8A6" />
                                    <circle cx="260" cy="184" r="12" fill="#7B2CBF" />
                                    <rect x="86" y="116" width="94" height="8" rx="4" fill="#93C5FD" />
                                    <rect x="86" y="132" width="68" height="8" rx="4" fill="#BFDBFE" />
                                    <rect x="340" y="116" width="94" height="8" rx="4" fill="#5EEAD4" />
                                    <rect x="340" y="132" width="66" height="8" rx="4" fill="#99F6E4" />
                                    <rect x="218" y="184" width="84" height="8" rx="4" fill="#DDD6FE" />
                                    <text x="86" y="82" fill="#0B1B34" fontSize="16" fontWeight="700">Audit</text>
                                    <text x="340" y="82" fill="#0B1B34" fontSize="16" fontWeight="700">Build</text>
                                    <text x="218" y="178" fill="#0B1B34" fontSize="15" fontWeight="700">Scale</text>
                                </svg>
                                <div>
                                    <h5 className="fw-bold mb-2">From audit to scalable delivery</h5>
                                    <p className="text-muted mb-0">
                                        We connect architecture, implementation, and release practices into one controlled engineering workflow.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Approach */}
            <section className="approach-section approach-lean py-5">
                <div className="container" data-aos="fade-up">
                    <div className="row g-4 align-items-start">
                        <div className="col-lg-4">
                            <div className="section-intro-sticky">
                                <span className="section-kicker">Approach</span>
                                <h3 className="fw-bold section-title text-start">A delivery process built for clarity.</h3>
                                <p className="text-muted section-subtitle text-start mb-0">
                                    A lean, transparent process designed to reduce risk and keep delivery focused on business value.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="approach-timeline">
                                {[
                                    ["Discover", "Clarify goals, constraints, workflows, and success metrics."],
                                    ["Design", "Define architecture, user flows, scope, and delivery priorities."],
                                    ["Develop", "Build secure, maintainable software with reviewable progress."],
                                    ["Deliver", "Ship stable releases with documentation and support readiness."]
                                ].map(([title, text], idx) => (
                                    <div className="approach-step" key={title}>
                                        <span>{String(idx + 1).padStart(2, '0')}</span>
                                        <div>
                                            <h5 className="approach-heading mb-1">{title}</h5>
                                            <p className="text-muted small mb-0">{text}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Choose Us */}
            <section className="why-us why-us-lean py-5">
                <div className="container" data-aos="fade-up">
                    <div className="row g-4 align-items-stretch">
                        <div className="col-lg-4">
                            <div className="why-summary h-100">
                                <span className="section-kicker">Why Choose Anmatics?</span>
                                <h3 className="fw-bold mb-3">Engineering that stays aligned with the business.</h3>
                                <p className="text-muted mb-0">
                                    We combine product thinking, technical depth, and delivery discipline so teams can ship reliable software without unnecessary complexity.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="why-capability-list">
                                {[
                                    {
                                        title: "Engineering Depth",
                                        text: "Frontend, backend, cloud, APIs, databases, and product architecture handled by one accountable team.",
                                        icon: faTools
                                    },
                                    {
                                        title: "Practical Architecture",
                                        text: "Systems designed for maintainability, performance, integration, and future change.",
                                        icon: faStream
                                    },
                                    {
                                        title: "Clear Ownership",
                                        text: "Defined scope, visible progress, structured communication, and fewer delivery blind spots.",
                                        icon: faSearch
                                    },
                                    {
                                        title: "Business Context",
                                        text: "Technology choices aligned with operations, cost, process efficiency, and growth goals.",
                                        icon: faDatabase
                                    },
                                    {
                                        title: "Structured Modernization",
                                        text: "Improve existing products incrementally without unnecessary rewrites or risky disruption.",
                                        icon: faRocket
                                    },
                                    {
                                        title: "Stable Delivery",
                                        text: "Cleaner release flow, safer deployments, measurable progress, and production readiness.",
                                        icon: faTools
                                    }
                                ].map((item, idx) => (
                                    <div className="why-capability" key={item.title}>
                                        <div className={`why-capability-icon why-capability-icon-${idx + 1}`}>
                                            <FontAwesomeIcon icon={item.icon} />
                                        </div>
                                        <div>
                                            <h6 className="fw-bold mb-1">{item.title}</h6>
                                            <p className="small text-muted mb-0">{item.text}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="about-cta about-cta-lean py-5" data-aos="fade-up">
                <div className="container">
                    <div className="cta-lean-panel">
                        <div>
                            <span className="section-kicker">Next Step</span>
                            <h3 className="fw-bold mb-2">Build software with a clear plan.</h3>
                            <p className="text-muted mb-0">
                                Share what you are building, modernizing, or scaling. We will help turn it into a practical technical roadmap.
                            </p>
                        </div>
                        <a href="#contact" className="btn btn-gradient btn-lg rounded-pill">
                            Plan Your Software Roadmap
                        </a>
                    </div>
                </div>
            </section>
        </section>
    );
};

export default About;
